import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import Loader from '../../images/whiteloader.svg';
import { processEmail, processInt, processPassword, processStrWithSpace, valdiatePage } from '../../global';
import { CreateUser, getPages } from '../../services/userservice';
import { setLoading } from '../../redux/appSlice';

const UserManagement = () => {
    const dispatch = useDispatch();
    const { loading, userInfo } = useSelector(state => state.appData);
    const history = useHistory();

    const d = {
        userId: '',
        accountNo: '',
        createdBy: userInfo.id
    };

    const [data, setData] = useState(d);

    useEffect(() => {
        if (!valdiatePage('/usermanagement')) {
            history.push('/login');
        }
    }, []);

    const updateData = (key, val) => {
        setData({ ...data, [key]: val });
    }

    const onCreateUser = async () => {
        if (!data.userId) {
            alert('Enter User ID');
            return;
        }
        if (!data.accountNo) {
            alert('Select Account No');
            return;
        }
        dispatch(setLoading({ data: true }));
        var rs = await CreateUser(data);
        dispatch(setLoading({ data: false }));
        alert(rs);
        setData(d);
    }

    return userInfo &&
        <section className="section">
            {
                <section>
                    <div className="section-header">
                        <h1>User Management</h1>
                    </div>

                    <div className="card" style={{ padding: 10 }}>
                        <div className="row pb-2">

                            <div className="col">
                                <label>User ID</label>
                                <input type="text" className="form-control" value={data.userId} onChange={(e) => updateData('userId', e.target.value)} />
                            </div>
                            <div className="col">
                                <label>Account No</label>
                                <input type="text" className="form-control" value={data.accountNo} onChange={(e) => updateData('accountNo', e.target.value)} />
                            </div>

                            <div className="col">
                                <button type="button" className="btn btn-primary" disabled={loading} style={{ marginTop: '1.3rem' }} onClick={onCreateUser}>
                                    {loading ? <img src={Loader} height="30" /> : 'Create User'}
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            }
        </section>
}

export default UserManagement;
